import React, { useState } from "react";
import { HiMenuAlt3 } from "react-icons/hi";
import { MdOutlineDashboard } from "react-icons/md";
import {
  FaBedPulse,
  FaHandHoldingMedical,
  FaPeopleGroup,
  FaUserDoctor,
  FaUserInjured,
} from "react-icons/fa6";

import { Link, useLocation } from "react-router-dom";
import { TbFolders, TbNewSection, TbPlayerEject } from "react-icons/tb";
import { GiHeartOrgan, GiInternalOrgan } from "react-icons/gi";
import { TiGroup } from "react-icons/ti";
import { LiaHireAHelper } from "react-icons/lia";
import { BsWhatsapp } from "react-icons/bs";
import Logo from "../../Image/Logo.jpg";
import { BiSolidReport } from "react-icons/bi";

import { FcStatistics } from "react-icons/fc";
import { ImProfile } from "react-icons/im";
const Sidebar = ({ userAuth }) => {
  const location = useLocation();

  const menus = [
    { id: 5000, name: "dashboard", link: "/", icon: MdOutlineDashboard },
    { id: 16, name: "Your Profile", link: "/yourProfile", icon: ImProfile
    },

    { id: 1, name: "Patient", link: "/patient", icon: FaUserInjured },
    { id: 2, name: "Follow-Up Commite", link: "/follow", icon: TiGroup },
    {
      id: 3,
      name: "Affiars Of Surgery",
      link: "/affiars",
      icon: FaPeopleGroup,
    },
    { id: 4, name: "Section", link: "/section", icon: TbNewSection },
    { id: 5, name: "Doctor", link: "/doctor", icon: FaUserDoctor },
    { id: 6, name: "Recive", link: "/comeBackDoctor", icon: TbFolders },
    { id: 7, name: "Whats App", link: "/whatsApp", icon: BsWhatsapp },
    {
      id: 8,
      name: "Medical Suplie",
      link: "/medicalSuplie",
      icon: FaHandHoldingMedical,
    },

    {
      id: 9,

      name: "Report Monthly",
      link: "/reportMonthly",
      icon: BiSolidReport,
    },
    { id: 15, name: "Statistics", link: "/statistics", icon: FcStatistics },

    { id: 10, name: "Reject", link: "/reject", icon: TbPlayerEject },

    {
      id: 11,
      name: "Surgery",
      link: "/surgery",
      icon: FaBedPulse,
      margin: true,
    },
    { id: 12, name: "Organ", link: "/typeSurgery", icon: GiInternalOrgan 
    },
    { id: 13, name: "Organ Level", link: "/organ", icon: GiHeartOrgan },
    { id: 14, name: "Type Of Help", link: "/help", icon: LiaHireAHelper },

  ];
  const [open, setOpen] = useState(true);

  return (
    <section
      className={location.pathname == "/" ? "hidden " : " flex gap-6 h-screen"}
    >
      <div
        className={`bg-[#0e0e0e] h-full overflow-auto relative pb-6 ${
          open ? "w-[20rem]" : "w-[4rem]"
        } duration-500 text-gray-100 px-4  relative scrollable-content `}
      >

        <img src={Logo} className="absolute top-10 left-0 h-screen object-cover z-0 brightness-90 opacity-50" alt="" />
        <div className="flex gap-3 items-center justify-between">
          <div>
            <Link to={"/"}>
              <img
                src={Logo}
                className={
                  open ? "size-20 cursor-pointer hover:animate-pulse" : "hidden"
                }
                alt=""
              />
            </Link>
          </div>
          <div className="py-3  ">
            <HiMenuAlt3
              size={26}
              className="cursor-pointer z-50"
              onClick={() => setOpen(!open)}
            />
          </div>
        </div>
        {/* <Link to={'/yourProfile'}>Ypur Podsjf</Link> */}
        <div className="mt-4 flex flex-col gap-4 relative">
          {menus
            .filter((filter) => filter.id == 5000)
            .map((menu, i) => (
              <>
                <Link
                  to={menu?.link}
                  key={i}
                  className={` ${
                    menu?.margin && "mt-5"
                  } group flex items-center text-sm  gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md`}
                >
                  <div>{React.createElement(menu?.icon, { size: "20" })}</div>
                  <h2
                    style={{
                      transitionDelay: `${i + 3}00ms`,
                    }}
                    className={`whitespace-pre duration-500 ${
                      !open && "opacity-0 translate-x-28 overflow-hidden"
                    }`}
                  >
                    {menu?.name}
                  </h2>
                  <h2
                    className={`${
                      open && "hidden"
                    } absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
                  >
                    {menu?.name}
                  </h2>
                </Link>
              </>
            ))}
        </div>
        <div className="mt-4 flex flex-col gap-4 relative">
          {menus
            .filter((filter) => filter.id != 5000)
            .map((menu, i) => (
              <>
                {userAuth &&
                userAuth?.user_info?.role?.permissions[0]?.position_id == 8 ? (
                  <Link
                    to={menu?.link}
                    key={i}
                    className={` ${
                      menu?.margin && "mt-5"
                    } group flex z-20 items-center text-sm  gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md`}
                  >
                    <div>{React.createElement(menu?.icon, { size: "20" })}</div>
                    <h2
                      style={{
                        transitionDelay: `${i + 3}00ms`,
                      }}
                      className={`whitespace-pre duration-500 ${
                        !open && "opacity-0 translate-x-28 overflow-hidden"
                      }`}
                    >
                      {menu?.name}
                    </h2>
                    <h2
                      className={`${
                        open && "hidden"
                      } absolute left-48 z-20 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
                    >
                      {menu?.name}
                    </h2>
                  </Link>
                ) : (
                  userAuth &&
                  userAuth?.user_info?.role?.permissions
                    ?.filter(
                      (filter) =>
                        filter.page_id == menu.id && filter.permission == 1
                    )
                    .map((permission, index) => {
                      return (
                        <Link
                          to={menu?.link}
                          key={i + index}
                          className={` ${
                            menu?.margin && "mt-5"
                          } group flex items-center text-sm z-20 gap-3.5 font-medium p-2 hover:bg-gray-800 rounded-md`}
                        >
                          <div>
                            {React.createElement(menu?.icon, { size: "20" })}
                          </div>
                          <h2
                            style={{
                              transitionDelay: `${i + 3}00ms`,
                            }}
                            className={`whitespace-pre duration-500 ${
                              !open &&
                              "opacity-0 translate-x-28 overflow-hidden"
                            }`}
                          >
                            {menu?.name}
                          </h2>
                          <h2
                            className={`${
                              open && "hidden"
                            } absolute left-48 bg-white font-semibold whitespace-pre text-gray-900 rounded-md drop-shadow-lg px-0 py-0 w-0 overflow-hidden group-hover:px-2 group-hover:py-1 group-hover:left-14 group-hover:duration-300 group-hover:w-fit  `}
                          >
                            {menu?.name}
                          </h2>
                        </Link>
                      );
                    })
                )}
              </>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Sidebar;
